export default "__VITE_ASSET__CHiax_fS__"